// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-navigation-minimal-place-select {
  flex: 0 0 auto;
  padding: 0 20px 8px;
  display: flex;
}
.dl-navigation-minimal-place-select__option {
  display: flex;
  align-items: center;
}
.dl-navigation-minimal-place-select__option-text {
  margin-left: 8px;
}
.dl-navigation-minimal-place-select__select {
  flex: 1;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/Navigation/PlaceSelect/PlaceSelect.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,mBAAA;EACA,aAAA;AACJ;AACI;EACI,aAAA;EACA,mBAAA;AACR;AAEI;EACI,gBAAA;AAAR;AAGI;EACI,OAAA;AADR","sourcesContent":[".dl-navigation-minimal-place-select {\n  flex: 0 0 auto;\n  padding: 0 20px 8px;\n  display: flex;\n}\n.dl-navigation-minimal-place-select__option {\n  display: flex;\n  align-items: center;\n}\n.dl-navigation-minimal-place-select__option-text {\n  margin-left: 8px;\n}\n.dl-navigation-minimal-place-select__select {\n  flex: 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
